var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.value)?_c('em',{staticClass:"text-info",domProps:{"textContent":_vm._s(_vm.text)}}):_c('span',[_vm._v("\n    "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }